import { FlexColumn, FlexResponsive, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { StyledDivider } from 'baseui/divider';
import { useRecoilValue } from 'recoil';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { useStyles } from '../../../hooks/useStyles';
import { notificationTypeState } from '../../../storage/notifications';
import { CurrentState } from '../../../types/asset';
import { StockDeviceState } from '../../../types/device';
import LabeledDataCard from '../labeledDataCard/LabeledDataCard';

type Props = Readonly<{
  currentState?: CurrentState | StockDeviceState;
  isEngineStall?: boolean;
}>;

function CurrentStateInfo({ currentState, isEngineStall = false }: Props) {
  const { formatDateFromTs } = useMoment();
  const { isSmall } = useBreakpoints();
  const { css, overrides } = useStyles();
  const labelWidth = '150px';
  const notificationType = useRecoilValue(notificationTypeState(currentState?.notificationType ?? -1));
  const voltage = currentState?.external_powersource_voltage || currentState?.backup_battery_voltage;

  return (
    <LabeledDataCard
      label="Estado Actual"
      rootStyleOverrides={{
        flexGrow: 4,
        flexShrink: 1,
        flexBasis: 0,
      }}
    >
      <FlexResponsive
        classNames={css({ alignItems: 'baseline' })}
        breakAt="large"
        gap={isSmall ? 0 : undefined}
      >
        <FlexColumn
          gap={0}
          classNames={css({ flex: 1, width: '100%' })}
        >
          <LabeledData
            label="Velocidad:"
            content={typeof currentState?.position_speed === 'number' ? `${currentState.position_speed} km/h` : '-'}
            labelWidth={labelWidth}
            inline={false}
            maxLines={3}
          />
          <StyledDivider style={overrides.dividerStyleOverrides} />
          <LabeledData
            label="Ignición:"
            content={
              typeof currentState?.engine_ignition_status == 'number'
                ? currentState?.engine_ignition_status
                  ? 'Encendida'
                  : 'Apagada'
                : '-'
            }
            labelWidth={labelWidth}
          />
          <StyledDivider style={overrides.dividerStyleOverrides} />
          <LabeledData
            label="Paro de motor:"
            content={isEngineStall ? 'Activo' : 'Inactivo'}
            labelWidth={labelWidth}
          />
          <StyledDivider style={overrides.dividerStyleOverrides} />
          <LabeledData
            label="Porcentaje de batería:"
            content={
              currentState?.battery_percentage !== undefined && currentState.battery_percentage !== null
                ? `${currentState.battery_percentage} %`
                : '-'
            }
            labelWidth={labelWidth}
            inline={false}
            maxLines={2}
          />
          <StyledDivider style={overrides.dividerStyleOverrides} />
          <LabeledData
            label="Voltaje:"
            content={typeof voltage === 'number' ? `${voltage} V` : '-'}
            labelWidth={labelWidth}
            inline={false}
            maxLines={2}
          />
        </FlexColumn>
        <FlexColumn
          gap={0}
          classNames={css({ flex: 1, width: '100%' })}
        >
          {isSmall && <StyledDivider style={overrides.dividerStyleOverrides} />}
          <LabeledData
            label="Ultima posición:"
            content={currentState?.timestamp ? formatDateFromTs(currentState.timestamp) : '-'}
            labelWidth={labelWidth}
            inline={false}
            maxLines={5}
          />
          <StyledDivider style={overrides.dividerStyleOverrides} />
          <LabeledData
            label="Tipo de reporte:"
            content={notificationType?.name || '-'}
            labelWidth={labelWidth}
            inline={false}
            maxLines={5}
          />
        </FlexColumn>
      </FlexResponsive>
    </LabeledDataCard>
  );
}

export default CurrentStateInfo;
